const abbreviatte = (str, count = 1) => `${str?.substring(0, count)}.`

export const formatName = user =>
  `${user?.preferred_name || user?.first_name}${
    user?.last_name ? ' ' + abbreviatte(user?.last_name) : ''
  }`

export const formatFullName = user =>
  `${user?.preferred_name || user?.first_name}${user?.last_name ? ` ${user.last_name}` : ''}`

export default formatName
